<n-slide-window *ngIf="pageReady"
    [(visible)]="windowVisible"
    [loading]="loading"
    width="7.5rem"
    (onHide)="close()">
    <n-header>
        <h1>{{title}}</h1>
        <n-help-link key="cifsipModify"></n-help-link>
    </n-header>

    <form [formGroup]="vm"
        [errorMessage]="errorMessage">
        <!-- IP地址/地址段 -->
        <n-form-item [label]="i18n.rules"
            required="true"
            [helpContent]="i18n.helpTip">
            <input id="modify-ip-white-list-rules"
                nInput
                formControlName="rules"
                nTooltipTrigger="focus"
                nTooltipPlacement="left"
                [nTooltip]="i18n.ipWhiteListModifyTips">
        </n-form-item>
    </form>

    <n-footer>
        <button id="modify-ip-white-list-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="modify-ip-white-list-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
